import $ from "jquery";
// import Timer from "@bd-utils/timer";
import RoomTimer from "@bd-utils/room-timer";
import BackgroundAudio from "@bd-utils/background-audio";
import Tutorial from "@bd-utils/tutorial";
import CompletionPopup from "@bd-utils/completion-popup";
import LocationInfo from "@bd-utils/location-info";
import OutroVideo from "@bd-utils/outro-video";
import RoomVideo from "@bd-utils/room-video";
import ChallengeAudio from "@bd-utils/challenge-audio";
import CONFIG from "@bd-core/config";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import { dispatch, getState, store } from "@bd-stores/store";
import bdapi from "@bd-core/bd-api";
import Storage from "@bd-utils/storage";
import {
    setAllRoomIsCompleted,
    updatePlayerPageId,
    updateAttributes,
    removeRoomAnswers,
    setIsRoomTimeOut,
    maybeUpdateRoomStatus,
    setIsTeamConnectorFinished,
    updateCurrentScreen,
    updatePlayersPageIdByID,
    setRoomStarted,
} from "@bd-core/firebase-actions";
import {
    setFinished,
    setRoomStatus,
    setTeamAnswers,
    setFinalTeamAnswers,
    getRoomStatus,
    setAllRoomCompleted,
    setIsMiddleState,
    setTotalAttempts,
    setTimeSpend,
    setIsRoomTimeout,
    setRoomScores,
    setLogos,
    setTeamConnectorFinished,
    setCurrentRoomStartedAt,
    setCurrentRoomShouldFinishedAt,
    setCurrentRoomFinishedAt,
    setCurrentChallengeIndex,
    setLeaderChanged,
    getLeaderChanged,
    setCurrentRoomScreen,
    getPlayers,
    isLeader,
    setIsLeader,
    setTeamConnectorReady,
    getNewLeaderAttributes,
    setCurrentOpenedChat,
    getCurrentRoomScreen,
    setEmailPhishingAction,
    isChangingLeader,
} from "@bd-stores/game-progress";
import {
    setCurrentPageId,
    setCurrentPageType,
    getCurrentPageId,
    getCurrentPageType,
    currentPageIsMainRoom,
} from "@bd-stores/user-progress";
import { getRoomByType } from "@bd-stores/game-data";

const GameLogic = {
    initialized: false,
    currentPageType: false,
    currentPageID: false,
    transisitonDuration: 275,

    async init() {
        if ($(".app").length < 1) return false;

        this.outroVideo = new OutroVideo();
        this.completionPopup = new CompletionPopup();
        // this.timer = new Timer(this.onTimeOut.bind(this));
        this.tutorial = new Tutorial();
        this.backgroundAudio = new BackgroundAudio();
        this.locationInfo = new LocationInfo();
        this.roomVideo = new RoomVideo();
        this.roomTimer = new RoomTimer(this.onRoomTimeout.bind(this));

        this.outroVideo.init();
        this.completionPopup.init();
        // this.timer.init();
        this.backgroundAudio.init();
        this.locationInfo.init();

        this.registerGlobalEvents();
        this.registerGlobalListener();

        // Initialize Firebase
        //-----------------------------------------------------------------------
        try {
            await fb.initializeGame();
        } catch (e) {
            console.error(e);
        }
        //-----------------------------------------------------------------------
    },

    registerGlobalListener() {
        const onRoomStatusChanged = (roomID, roomStatus, roomData) => {
            if (!roomStatus) return;
            const currentPageId = getCurrentPageId();
            const isCurrentPageMainroom = currentPageIsMainRoom();

            const possibleStatuses = [
                "is-status-open",
                "is-status-started",
                "is-status-completed",
            ];

            if (currentPageId == roomID) {
                const $status = $(".js-room-status");
                // prettier-ignore
                $status.removeClass(possibleStatuses);
                $status.addClass(roomStatus);
            }

            if (isCurrentPageMainroom) {
                const $roomItem = $(`.js-room-item[data-page="${roomID}"]`);

                roomStatus == "is-status-completed"
                    ? $roomItem.addClass("is-finished")
                    : $roomItem.removeClass("is-finished");
            }

            if (roomStatus == "is-status-completed") {
                /* Show completion popup */

                /**
                 * @type {BD_StoreGameProgress['isRoomTimeout']}
                 */
                let roomTimeout = {};
                if (roomData.isTimeOut) {
                    roomTimeout[roomID] = true;
                    store.dispatch(setIsRoomTimeout(roomTimeout));
                }
                const isRoomMiddleState = roomData?.isMiddleState || false;
                const roomAnswers = roomData?.finalAnswers || {};

                this.completionPopup.show(
                    roomID,
                    isRoomMiddleState,
                    roomAnswers,
                );

                this.roomTimer.stopTimer(roomID);
                // this.playOutroVideo();
            } else {
                /*
                 * On status open & started it will check the state of completion popup
                 * status might changed since you can edit them via backend
                 * and when the room is set from finish to open or started, we need to reset the state of completion popup(to unseen)
                 */
                this.completionPopup.maybeResetState(roomID);
            }
        };

        const onRoomDataChanged = (e, eventData) => {
            let currentPageId = getCurrentPageId();
            const isCurrentPageMainroom = currentPageIsMainRoom();
            const roomsData = eventData?.data || false;
            let currentRoomIsFinish = false;
            let currentRoomHasAnswer = false;

            const gameProgress = getState().gameProgress;
            const isTeamConnectorFinished =
                gameProgress.isTeamConnectorFinished;

            if (!isTeamConnectorFinished) {
                const roomType = "teamconnector_room";
                const teamConnectorPageId = getRoomByType(roomType);

                if (teamConnectorPageId !== 0)
                    currentPageId = teamConnectorPageId;
            }

            /**
             * @type {BD_StoreGameProgress['teamAnswers']}
             */
            let tmpTeamAnswers = {};

            /**
             * @type {BD_StoreGameProgress['finalTeamAnswers']}
             */
            let tmpFinalTeamAnswers = {};

            /**
             * @type {BD_StoreGameProgress['roomStatus']}
             */
            let tmpRoomStatus = {};

            /**
             * @type {BD_StoreGameProgress['totalAttempts']}
             */
            let tmpRoomAttempts = {};

            /**
             * @type {BD_StoreGameProgress['timeSpend']}
             */
            let tmpTimeSpend = {};

            /**
             * @type {BD_StoreGameProgress['isRoomTimeout']}
             */
            let tmpRoomTimeout = {};

            /**
             * @type {BD_StoreGameProgress['roomScores']}
             */
            let tmpRoomScores = {};

            /**
             * @type {BD_StoreGameProgress['logos']}
             */
            let tmpRoomLogos = {};

            /**
             * @type {BD_StoreGameProgress['roomCurrentScreen']}
             */
            let tmpRoomScreen = {};
            let tmpIsLeaderChanged = {};

            if (roomsData) {
                $.each(roomsData, (roomID, room) => {
                    // @ts-ignore
                    roomID = isNaN(roomID) ? roomID : parseInt(roomID);

                    //Handle room status changed
                    const roomStatus = room?.status;
                    const timeSpend = room?.timeSpend;
                    const attempt = room?.totalAttempt;
                    const isTimeOut = room?.isTimeOut;
                    const score = room?.totalScore;
                    const logo = room?.logo;
                    const roomScreen = room?.currentScreen;

                    if (roomStatus) {
                        onRoomStatusChanged(roomID, roomStatus, room);
                        tmpRoomStatus[roomID] = roomStatus;
                    }

                    if (timeSpend) {
                        tmpTimeSpend[roomID] = timeSpend;
                    }

                    if (attempt) {
                        tmpRoomAttempts[roomID] = attempt;
                    }

                    if (isTimeOut) {
                        tmpRoomTimeout[roomID] = isTimeOut;
                    }

                    if (score) {
                        tmpRoomScores[roomID] = score;
                    }

                    if (logo) {
                        tmpRoomLogos[roomID] = logo;
                    }

                    if (roomScreen) {
                        tmpRoomScreen[roomID] = roomScreen;
                    }

                    if (room.isLeaderChanged) {
                        tmpIsLeaderChanged[roomID] = true;
                    } else {
                        tmpIsLeaderChanged[roomID] = false;
                    }

                    //handle room answers changed
                    const teamAnswers = room?.answers || {};
                    const finalTeamAnswers = room?.finalAnswers || {};

                    tmpTeamAnswers[roomID] = teamAnswers;
                    tmpFinalTeamAnswers[roomID] = finalTeamAnswers;

                    const isCompleted = roomStatus == "is-status-completed";
                    const isCurrentPage = currentPageId == roomID;

                    if (isCurrentPage) {
                        if (isCompleted) currentRoomIsFinish = true;
                        if (finalTeamAnswers) currentRoomHasAnswer = true;
                    }
                });
            }

            store.dispatch(setTeamAnswers(tmpTeamAnswers));
            store.dispatch(setFinalTeamAnswers(tmpFinalTeamAnswers));
            store.dispatch(setRoomStatus(tmpRoomStatus));
            store.dispatch(setTotalAttempts(tmpRoomAttempts));
            store.dispatch(setTimeSpend(tmpTimeSpend));
            store.dispatch(setIsRoomTimeout(tmpRoomTimeout));
            store.dispatch(setRoomScores(tmpRoomScores));
            store.dispatch(setLogos(tmpRoomLogos));
            store.dispatch(setCurrentRoomScreen(tmpRoomScreen));
            store.dispatch(setLeaderChanged(tmpIsLeaderChanged));

            this.maybeAllRoomCompleted();

            if (!this.initialized) {
                this.initializePage(currentPageId, true);
                this.initialized = true;
            }

            //Set DOM for correct answer
            else if (
                currentRoomIsFinish ||
                currentRoomHasAnswer ||
                isCurrentPageMainroom
            ) {
                const currentTypePage = getCurrentPageType();
                const currComponent = bdjs.getComponent(currentTypePage);
                if (currComponent?.setGameState) currComponent.setGameState();
            }

            if (roomsData[currentPageId]) {
                store.dispatch(
                    setCurrentRoomStartedAt(
                        roomsData[currentPageId].startedAt ?? null,
                    ),
                );
                store.dispatch(
                    setCurrentRoomShouldFinishedAt(
                        roomsData[currentPageId].shouldFinishedAt ?? null,
                    ),
                );
                store.dispatch(
                    setCurrentRoomFinishedAt(
                        roomsData[currentPageId].finishedAt ?? null,
                    ),
                );
                const pageId = parseInt(currentPageId.toString());
                store.dispatch(setCurrentPageId(pageId));

                if (roomsData[currentPageId].startedAt) {
                    this.startRoomTimer();
                }

                if (roomsData[currentPageId].finishedAt) {
                    this.updateRoomTimer(roomsData[currentPageId].finishedAt);
                }

                if (roomsData[currentPageId].currentOpenedChat) {
                    store.dispatch(
                        setCurrentOpenedChat(
                            roomsData[currentPageId].currentOpenedChat,
                        ),
                    );
                }

                if (roomsData[currentPageId].emailPhishing) {
                    store.dispatch(
                        setEmailPhishingAction(
                            roomsData[currentPageId].emailPhishing,
                        ),
                    );
                }
            }
        };

        const onTeamAttributesChanged = (e, eventData) => {
            const isMiddleState = eventData?.data?.isMiddleState || false;
            store.dispatch(setIsMiddleState(isMiddleState));

            const isTcFinished =
                eventData?.data?.isTeamConnectorFinished || false;
            store.dispatch(setTeamConnectorFinished(isTcFinished));
            if (isTcFinished) {
                const currentTypePage = getCurrentPageType();
                const currComponent = bdjs.getComponent(currentTypePage);
                if (currComponent?.setGameState) currComponent.setGameState();
            }

            const newLeaderAttributes = getNewLeaderAttributes();
            const currentPlayerId = CONFIG.user.id;
            // const teamLeader = eventData?.data?.leader;
            const isLeaderChanging = isChangingLeader();

            if (isLeaderChanging) {
                if (newLeaderAttributes.newLeader === currentPlayerId) {
                    store.dispatch(setIsLeader(true));
                } else {
                    store.dispatch(setIsLeader(false));
                }

                const currentTypePage = getCurrentPageType();
                const currComponent = bdjs.getComponent(currentTypePage);

                if (currentTypePage !== "teamconnector_room") {
                    if (currComponent?.init) {
                        currComponent.destroy();
                        currComponent.init();
                        this.listenScreenLoading();
                        GameLogic.toggleNarrative();
                    }
                }
            }

            const isFinished = eventData?.data?.isFinished || false;
            if (!isFinished) return;

            store.dispatch(setFinished(true));
            // this.timer.stopTimer();
            bdjs.showLoading();

            setTimeout(() => {
                $(".app").html("");

                setTimeout(() => this.onFinish(), this.transisitonDuration);
            }, this.transisitonDuration);
        };

        const onPlayersDataChanged = (e, eventData) => {
            const playersData = eventData?.data || [];
            const currentPlayer = CONFIG.user.id;
            const playerData = playersData.find(
                (player) => player.userId == currentPlayer,
            );
            const currentPageId = playerData?.currentPageId;
            const is_leader = isLeader();

            if (currentPageId && !is_leader) {
                this.goToPage(currentPageId);
            }

            // console.log(currentPageId);

            setTimeout(() => {
                // // open switch leader screen
                const roomId = parseInt(currentPageId?.toString());
                if (!isNaN(roomId)) {
                    this.openSwithLeaderScreen(roomId);
                }
            }, /* this.transisitonDuration */ 500);

            this.locationInfo.render();

            const teamConnectorReady = eventData.data.every(
                (obj) => obj.hasSeenGameIntro,
            );
            dispatch(setTeamConnectorReady(teamConnectorReady));
        };

        // This two listener is essentially the same, because
        // bd__roomDataChanged be triggered even if there's no data inside it,
        // but in case that logic changed, we still be able to init the current
        // page explicitly.with the subscribe function, so it is important to
        // keep it there
        // subscribe(onRoomDataChanged, "isFirebaseInitialized");
        bdjs.listen("bd__roomDataChanged", onRoomDataChanged);

        bdjs.listen("bd__teamAttributeChanged", onTeamAttributesChanged);

        bdjs.listen("bd__playersStateChanged", onPlayersDataChanged);

        this.listenGameProgressChanged();
    },

    registerGlobalEvents() {
        const $app = $(".app");

        $app.on("click", "[data-change-page]", this.changePage.bind(this));

        /* Open room briefing popup */
        $app.on("click", ".js-info-button", this.toggleBriefing);

        /* Close room briefing popup */
        $app.on("click", ".js-briefing-close", this.toggleBriefing);

        /* toggle source popup */
        $app.on("click", ".js-sources-button", this.toggleSourcesPopup);

        $app.on("click", ".js-search-and-find-button", this.toggleSearchFind);

        $(document).on("click", function (e) {
            const $elRoomBrief = $(".roomBrief");

            if ($elRoomBrief.length) {
                /**
                 * Check is element related to current event
                 * @param {HTMLElement} el
                 * @param {typeof e} e
                 * @returns {Boolean}
                 */
                const checkRelatedTarget = (el, e) => el.contains(e.target);

                const shouldClose = !checkRelatedTarget($elRoomBrief[0], e);
                if (shouldClose) $elRoomBrief.removeClass("is-open");
            }
        });

        $(window).on("resize", () => {
            const isFunction =
                typeof window.screenCalculationFunc === "function";
            if (isFunction) window.screenCalculationFunc(); // eslint-disable-line no-undef
        });

        // $(window).on("beforeunload", () => {
        //     return "Are you sure you want to leave?";
        // });
    },

    /**
     * This function is to listen an event when game progress was edited from backend
     */
    listenGameProgressChanged() {
        const onGameProgressChanged = (e, eventData) => {
            const shouldClearData = eventData?.data?.clearData || false;
            const needReload = eventData?.data?.needReload || false;
            const removedPlayer = eventData?.data?.removedPlayer || false;
            const teamStatusChangedTo =
                eventData?.data?.teamStatusChangedTo || false;
            const teamCode = eventData?.data?.teamCode || false;

            if (teamStatusChangedTo || teamCode) {
                bdapi.post("game/change-status", {
                    status: teamStatusChangedTo,
                    code: teamCode,
                });
            }

            if (removedPlayer == CONFIG.user.id) {
                bdapi.post("member/kick-member", {
                    member_id: removedPlayer,
                    from_admin: true,
                });
                window.location.reload();
            }

            if (shouldClearData || needReload) {
                updateAttributes({
                    clearData: null,
                    needReload: null,
                }).then(async () => {
                    /**
                     * Clear all data from previous game. Answers, Popup State
                     */
                    if (shouldClearData) {
                        Storage.remove("states");
                        try {
                            await removeRoomAnswers();
                        } catch (err) {
                            console.error(err);
                        }
                        updatePlayerPageId(null);
                    }

                    if (needReload) window.location.reload();
                });
            }
        };

        bdjs.listen("bd__teamAttributeChanged", onGameProgressChanged);
    },

    onFinish(isTimeout = false) {
        const video = isTimeout
            ? this.outroVideo.videoTimeout
            : this.outroVideo.videoFinish;

        try {
            if (video) {
                bdjs.hideLoading();
                this.outroVideo.showVideo(isTimeout);

                setTimeout(() => {
                    video.play().catch((error) => {
                        // Autoplay was blocked. Do something
                        console.error("Unable to start auto play", error);
                    });
                }, this.transisitonDuration);
            } else {
                this.outroVideo.afterPlay();
            }
        } catch (error) {
            console.error(error);
        }
    },

    /**
     * Handle narrative popup wheither to open or close
     */
    toggleNarrative() {
        const $narrativePopup = $(".js-narrative-popup");
        const $blur = $(".blur");

        const hasOpen = $narrativePopup.hasClass("is-open");
        const isOpen = !hasOpen;

        $narrativePopup.toggleClass("is-open", isOpen);
        $blur.toggleClass("is-blurred", isOpen);
    },

    /**
     * Handle search and find screen,
     * after close the popup,
     * open the briefing popup
     */
    toggleSearchFind() {
        const roomId = getCurrentPageId();
        const $this = $(".js-search-and-find-button");

        $this.parent().addClass("enter");
        setTimeout(() => {
            $(".search-and-find .screen__img").css("opacity", 0);
            updateCurrentScreen(roomId, "puzzle-screen");
        }, 500);

        setTimeout(() => {
            $(".narrative-layer").css({
                opacity: 0,
                "pointer-events": "none",
            });
            $(".js-narrative-popup").removeClass("is-open");
        }, 500);
    },

    /**
     * Handle briefing/instruction popup wheither to open or close
     */

    // TODO: debug here to investigate briefing popup bug https://www.pivotaltracker.com/story/show/186872215
    toggleBriefing() {
        let roomId = getCurrentPageId();
        const $briefingPopup = $(".js-info-popup");
        const $blur = $(".blur");
        const hasOpen = $briefingPopup.hasClass("active");
        const isOpen = !hasOpen;

        // fix https://www.pivotaltracker.com/story/show/186872215
        if (!isNaN(parseInt(roomId.toString()))) {
            roomId = parseInt(roomId.toString());
        }

        let states = Storage.get("states", {});
        if (!states?.briefing) states.briefing = [];

        if (!states.briefing.includes(roomId)) {
            $briefingPopup.addClass("active");
            $blur.addClass("is-blurred");
            $(".js-narrative-popup").removeClass("is-open");

            states.briefing.push(roomId);
            Storage.set("states", states);
        } else {
            $briefingPopup.toggleClass("active", isOpen);
            $blur.toggleClass("is-blurred", isOpen);
        }
    },

    /**
     * Handle sources popup  wheither to open or close
     */
    toggleSourcesPopup() {
        const $sourcePopup = $(".js-source-popup");
        const isOpened = $sourcePopup.hasClass("active");

        $sourcePopup.toggleClass("active", !isOpened);
    },

    startRoomTimer() {
        const currentPageId = getCurrentPageId();
        const roomStatus = getRoomStatus(currentPageId);

        if (roomStatus !== "is-status-completed") {
            this.roomTimer.init(currentPageId);
        }
    },

    updateRoomTimer(finishedAt) {
        const currentPageId = getCurrentPageId();

        this.roomTimer.init(currentPageId, finishedAt);
    },

    onRoomTimeout() {
        const currentPageId = getCurrentPageId();
        const currentPageType = getCurrentPageType();
        const roomStatus = "is-status-completed";

        setIsRoomTimeOut(currentPageId);
        maybeUpdateRoomStatus(currentPageId, roomStatus);
        // setTimeSpentToFinish(currentPageId, totalTimeInSecond);

        if (currentPageType === "teamconnector_room")
            setIsTeamConnectorFinished(true);
    },

    playIntroVideo() {
        const currentPageId = getCurrentPageId();
        const $introVideo = $("#intro-video");
        const isPlaying = $introVideo.hasClass("is-open");

        if (!isPlaying) {
            this.roomVideo.init(currentPageId, "intro");
        }
    },

    playOutroVideo() {
        const currentPageId = getCurrentPageId();
        const $outroVideo = $("#outro-video");
        const isPlaying = $outroVideo.hasClass("is-open");

        if (!isPlaying) {
            this.roomVideo.init(currentPageId, "outro");
        }
    },

    playAudioChallenge() {
        const $audioChallenge = new ChallengeAudio();
        const currentPageId = getCurrentPageId();
        const $audio = $(".js-audio-challenge");

        const hasPlayed = $audio.hasClass("is-played");

        if (!hasPlayed) {
            $audioChallenge.init(currentPageId);
        }
    },

    changePage(e) {
        const $el = $(e.currentTarget);
        const pageId = $el.attr("data-change-page");
        const currentPageId = getCurrentPageId();

        if (
            $el.hasClass("is-locked") ||
            $el.parent().hasClass("is-notready") ||
            $el.hasClass("is-finished")
        ) {
            return;
        }

        updateCurrentScreen(currentPageId, null);
        this.goToPage(pageId);
    },

    // TODO: debug here to investigate why the game is slow loading in Korea
    goToPage(pageId) {
        const currentPageId = getCurrentPageId();
        if (currentPageId == pageId) return;

        bdjs.showLoading();
        $(".site").removeClass("overlay-opened");

        setTimeout(() => {
            const is_leader = isLeader();
            if (is_leader) this.forcePlayersOnSameRoom(pageId);

            // // open switch leader screen
            // const roomId = parseInt(pageId.toString());
            // if (!isNaN(roomId)) {
            //     this.openSwithLeaderScreen(roomId);
            // }

            this.initializePage(pageId);
        }, this.transisitonDuration);
    },

    async onTimeOut() {
        bdjs.showLoading();

        await bdjs.goAsync(bdapi.post("game/timeout"));

        setTimeout(() => {
            $(".app").html("");

            this.onFinish(true);
        }, this.transisitonDuration);
    },

    forcePlayersOnSameRoom(pageId) {
        const players = getPlayers();

        if (!players || !players.length || pageId == undefined) {
            return;
        }

        players.forEach((player) => {
            const playerId = player.userId;
            updatePlayersPageIdByID(playerId, pageId);
        });
    },

    initializePage(pageId, dontUpdate) {
        pageId = isNaN(parseInt(pageId)) ? pageId : parseInt(pageId);
        updatePlayerPageId(pageId);

        const pageData = this.getPageData(pageId);
        const component = bdjs.getComponent(pageData.type);
        const currentPageType = getCurrentPageType();

        if (component) {
            // this.hideComponent();

            if (currentPageType) {
                const prevComponent = bdjs.getComponent(currentPageType);

                if (prevComponent) {
                    prevComponent.destroy();
                }
            }

            store.dispatch(setCurrentPageId(pageId));
            store.dispatch(setCurrentPageType(pageData.type));

            component._setData(pageData.data);
            component.init();

            // this.startRoomTimer();
            //TODO: move room started flag when all player ready
            const excludedRoomType = ["teamconnector_room", "main-room"];
            if (!excludedRoomType.includes(pageData.type) && isLeader()) {
                setRoomStarted(pageId);
            }

            this.locationInfo.render();

            if (!dontUpdate) {
                const currentScreen = getCurrentRoomScreen(pageId);
                const is_leader = isLeader();

                if (is_leader && !currentScreen)
                    updateCurrentScreen(pageId, "search-find");

                updatePlayerPageId(pageId);
            }

            this.listenScreenLoading();
        } else {
            console.error("Component: Can't find component " + pageData.type);
        }
    },

    openSwithLeaderScreen(roomId) {
        const rooms = CONFIG.game.rooms;

        const currentChallengeIndex =
            rooms.findIndex((r) => r.id === roomId) ?? 0;
        dispatch(setCurrentChallengeIndex(currentChallengeIndex));

        const leaderChanged = getLeaderChanged();
        const isCurrentChallengeLeaderChanged =
            leaderChanged?.[roomId] ?? false;

        if (currentChallengeIndex > 1 && !isCurrentChallengeLeaderChanged) {
            bdjs.trigger("bd__onOpenLeaderSwitch");
        }
    },

    getPageData(pageId) {
        let _data = {};

        /**
         * @type {BD_RoomType | undefined}
         */
        let _type = undefined;

        $.each(CONFIG.game.rooms, (index, room) => {
            if (room.id == pageId) {
                _type = room.type;
                _data = room.room;
                return false;
            }
        });

        return {
            type: _type,
            data: _data,
        };
    },

    // TODO: debug here to investigate why the game is slow loading in Korea
    listenScreenLoading() {
        /**
         * @type {JQuery<HTMLImageElement>}
         */
        const $screenImg = $(".screen__img");
        const isScreenImgExist = $screenImg.length > 0;
        const currentPageId = getCurrentPageId();

        const hideLoadingAndInitTutorial = (forceHide = false) => {
            const userProgress = getState().userProgress;
            if (forceHide || userProgress.isFirebaseInitialized) {
                bdjs.hideLoading();
            }
            // Initialize tutorial separately to not block loading state
            setTimeout(() => {
                this.tutorial.init(currentPageId);
            }, 0);
        };

        const onLoaded = () => {
            if (
                isScreenImgExist &&
                typeof window.screenCalculationFunc === "function"
            ) {
                window.screenCalculationFunc();
            }
            // Force hide loading after image is loaded, regardless of Firebase state
            hideLoadingAndInitTutorial(true);
        };

        // If no screen image exists or image is already loaded, hide loading immediately
        if (!isScreenImgExist || ($screenImg[0] && $screenImg[0].complete)) {
            onLoaded();
            return;
        }

        // Set a maximum timeout for image loading
        const imageLoadTimeout = setTimeout(() => {
            console.warn("Image load timed out - hiding loading screen anyway");
            onLoaded();
        }, 5000); // 5 second timeout

        // Handle successful load
        $screenImg.one("load", () => {
            clearTimeout(imageLoadTimeout);
            onLoaded();
        });

        // Handle load error
        $screenImg.one("error", () => {
            clearTimeout(imageLoadTimeout);
            console.warn("Screen image failed to load");
            onLoaded();
        });
    },

    maybeAllRoomCompleted() {
        const rooms = CONFIG.game.rooms;
        let isAllRoomCompleted = true;

        $.each(rooms, (index, room) => {
            if (
                room.type === "main-room" ||
                room.type === "no_challenge" ||
                room.type === "hint" ||
                room.type === "audio" ||
                room.type === "teamconnector_room"
            )
                return true;

            const roomStatus = getRoomStatus(room.id);

            if (roomStatus !== "is-status-completed") {
                isAllRoomCompleted = false;
                return false;
            }
        });

        if (isAllRoomCompleted) {
            setAllRoomIsCompleted(true);
            store.dispatch(setAllRoomCompleted(true));
        }
    },
};

export default GameLogic;
